'use strict';
import {
  GET_REPLY_MSG_LIST,
  UPDATE_PROBLEM_MODAL,
  UPDATE_PROBLEM_MODAL_LOADING_STATUS,
} from '../actions/problemDetail';

const defVal = {
  modalItme: null,
  oprType: null,
  visible: false,
  loadingProblemList: false,
  replyMsgList: [],
  total: 0,
  current: 0,
  opType: 'ADD'
};

export default (state = defVal, action) => {
  switch (action.type) {
    case GET_REPLY_MSG_LIST:
      return Object.assign({}, state, {
        replyMsgList: action.replyMsgList,
        total: action.total,
        current: action.current,
      });
      
    case UPDATE_PROBLEM_MODAL:
      return Object.assign({}, state, {
        modalItme:action.modalItme,
        visible: action.visible,
        opType: action.opType
      });

    case UPDATE_PROBLEM_MODAL_LOADING_STATUS:
      return Object.assign({}, state, {
        loadingProblemList: action.loadingProblemList
      });

    default:
      return state;
  }
};
